<template>
  <v-container class="p-insure px-0">
    <v-layout>
      <Stepper :value="1" class="stepper"></Stepper>
    </v-layout>
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="投保" class="insure-card">
          <h3>诚泰团体人身意外伤害保险</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 企业信息 -->
            <section class="form-section">
              <p class="mb-4">企业及联系人信息</p>

              <div class="form-item">
                <label>企业名称</label>
                <v-text-field v-model="form.companyName" :solo="solo" :rules="rules.companyName"></v-text-field>
              </div>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>企业证件号</label>
                  <v-select
                    v-model="form.companyCardType"
                    :items="companyCardTypies"
                    :solo="solo"
                    label
                  ></v-select>
                </v-flex>
                <v-flex class="form-item">
                  <v-text-field
                    v-model="form.companyCardNo"
                    :solo="solo"
                    :rules="rules.companyCardNo"
                    label
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="form-item-btn-mb">
                <v-flex class="form-item form-item-left">
                  <label>营业执照</label>
                  <CUpload
                    class="form-item-btn-wrap"
                    :on-success="onUploadSuccess"
                    show-type="picture"
                    :limit="1"
                  >上传营业执照</CUpload>
                </v-flex>
                <v-flex class="form-item">
                  <a class="primary-text mt-2" @click="sampleVisible = true">查看样例</a>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>联系人姓名</label>
                  <v-text-field v-model="form.contactName" :solo="solo" :rules="rules.contactName"></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>座机电话</label>
                  <v-text-field
                    v-model="form.contactPhoneNumber"
                    :solo="solo"
                    :rules="rules.contactPhoneNumber"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-item">
                <label>联系邮箱</label>
                <v-text-field v-model="form.contactEmail" :solo="solo" :rules="rules.contactEmail"></v-text-field>
              </div>
            </section>
            <hr class="line">
            <!-- 投保信息 -->
            <section class="form-section">
              <p class="mb-4">投保信息</p>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>生效日期</label>
                  <v-menu
                    ref="dateMenu"
                    v-model="effectBeginDateMenuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="date-input"
                      v-model="form.effectBeginDate"
                      :solo="solo"
                      :rules="rules.effectBeginDate"
                      append-icon="calendar_today"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="form.effectBeginDate"
                      :header-date-format="date=>date"
                      :min="minEffectBeginDate"
                      no-title
                      @input="effectBeginDateMenuVisible = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="form-item">
                  <label>保障期限</label>
                  <v-select v-model="form.effectDuration" :items="effectDurationList" :solo="solo"></v-select>
                </v-flex>
              </v-layout>
              <v-layout class="form-item-btn-mb">
                <v-flex class="form-item form-item-left">
                  <label>投保员工</label>
                  <div class="form-item-btn-wrap">
                    <v-btn
                      class="form-item-btn"
                      color="primary"
                      block
                      @click="employeeManageVisible = true"
                    >{{ employees.length === 0?"填写员工信息":"修改员工信息" }}</v-btn>
                  </div>
                </v-flex>
                <v-flex class="form-item">
                  <v-layout
                    v-show="employees.length > 0"
                    align-center
                    fill-height
                  >员工总数：{{ employees.length }}</v-layout>
                </v-flex>
              </v-layout>
            </section>
            <hr class="line">
            <!-- 保障方案 -->
            <section class="plan-section">
              <p class="mb-4">保障方案</p>
              <InsurancePlanTable
                v-model="form.amount"
                :employees="employees"
                :code="code"
                :plan-id="form.productPlanId"
                :effect-duration="form.effectDuration"
                :plan-list.sync="planList"
              ></InsurancePlanTable>
            </section>
          </v-form>
        </CSection>
      </v-flex>
      <v-flex shrink class="right-section">
        <div v-pin="{padding: {top: 136}}" class="pay-card block">
          <div>
            总保费
            <span class="display-1 primary-text">￥{{ form.amount.toFixed(2) }}</span>
          </div>
          <hr class="line">
          <v-layout>
            <v-flex shrink>
              <v-checkbox v-model="form.agree" class="checkbox" label></v-checkbox>
            </v-flex>
            <v-flex>
              我已仔细阅读且确认《
              <a class="primary-text" @click="healthVisible = true">健康告知</a>》的各项全部为否，并接受投保须知及以下条款和告知《
              <a class="primary-text" @click="noticeVisible=true">投保须知及声明</a>》《
              <a class="primary-text" @click="tkVisible = true">保险条款</a>》
            </v-flex>
          </v-layout>
          <v-btn
            class="pay-btn"
            :disabled="!form.agree"
            :loading="loading"
            color="primary"
            block
            @click="onPay"
          >去支付</v-btn>
        </div>
      </v-flex>
    </v-layout>

    <Sample v-model="sampleVisible"></Sample>

    <EmployeeManage v-model="employees" :visible.sync="employeeManageVisible"></EmployeeManage>
    <Notice v-model="noticeVisible"></Notice>
    <TKDialog v-model="tkVisible" code="1001"></TKDialog>
    <Health v-model="healthVisible"></Health>
  </v-container>
</template>

<script>
import Stepper from "./components/Stepper";
import InsurancePlanTable from "@/components/Order/InsurancePlanTable";
import EmployeeManage from "@/components/Order/EmployeeManage";
import Sample from "./components/BusinessLicenseSample";
import Notice from "./components/Notice";
import Health from "./components/Health";
import TKDialog from "./components/TKDialog";

import validate from "@/assets/js/validate";

export default {
  components: {
    Stepper,
    InsurancePlanTable,
    EmployeeManage,
    Sample,
    Notice,
    Health,
    TKDialog
  },
  props: {
    code: String
  },
  data() {
    return {
      solo: true,
      companyCardTypies: [
        { text: "统一社会信用代码", value: 4 },
        { text: "组织机构代码", value: 1 },
        { text: "税务登记证", value: 2 },
        { text: "营业执照", value: 3 }
      ],
      effectDurationList: [
        { text: "1年", value: 12 },
        { text: "11个月", value: 11 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ],
      formValid: true,
      form: {
        companyName: "",
        companyCardType: 4,
        companyCardNo: "",
        contactName: "",
        contactPhoneNumber: "",
        contactEmail: "",
        // 生效日期
        effectBeginDate: "",
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0,
        // 营业执照图片文件
        businessLicenseFile: null
      },
      rules: {
        companyName: [v => !!v || "请输入企业名称"],
        companyCardNo: [
          v => !!v || "请输入对应的证件号",
          v => {
            if (this.form.companyCardType === 1) {
              return (
                validate.isOrganizationCode(v) || "请输入正确的组织机构代码"
              );
            } else if (this.form.companyCardType === 2) {
              return (
                validate.isTaxRegistrationCertificate(v) ||
                "请输入正确的税务登记证"
              );
            } else if (this.form.companyCardType === 3) {
              return validate.isBusinessLicense(v) || "请输入正确的营业执照";
            }
            return (
              validate.isUnifiedSocialCreditCode(v) ||
              "请输入正确的统一社会信用代码"
            );
          }
        ],
        contactName: [
          v => {
            if (!v) {
              return "请输入联系人姓名";
            }
            if (!validate.isChineseName(v)) {
              return "请输入联系人中文姓名";
            }
            return true;
          }
        ],
        contactPhoneNumber: [
          v => {
            if (!v) {
              return "请输入座机电话";
            }
            if (!validate.isTelephone(v)) {
              return "请输入正确的座机电话";
            }
            return true;
          }
        ],
        contactEmail: [
          v => {
            if (!v) {
              return "请输入联系邮箱";
            }
            if (!validate.isEmail(v)) {
              return "请输入正确的联系邮箱";
            }
            return true;
          }
        ],
        effectBeginDate: [v => !!v || "请选择生效日期"]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      // 控制营业执照样例显示
      sampleVisible: false,
      noticeVisible: false,
      tkVisible: false,
      healthVisible: false,
      // 控制员工管理显示
      employeeManageVisible: false,
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      planList: [],
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.$store.dispatch("getUserInfo");
    this.form.effectBeginDate = this.minEffectBeginDate = this.$miment()
      .add(3, "DD")
      .format("YYYY-MM-DD");
    if (process.env.NODE_ENV === "development") {
      // 测试信息
      this.form = {
        companyName: "德玛西亚",
        companyCardType: 4,
        companyCardNo: "91120103MA06J25628",
        contactName: "盖伦",
        contactPhoneNumber: "010-88888888",
        contactEmail: "xiaoliang.li@chinatalentgroup.com",
        // 生效日期
        effectBeginDate: this.minEffectBeginDate,
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0
      };
      this.employees = [
        {
          name: "包婷珊",
          idCard: "513436200005306058",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1
          }
        },
        {
          name: "储庆妹",
          idCard: "51343620000530647X",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1
          }
        },
        {
          name: "皇甫国言",
          idCard: "513436200005308811",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1
          }
        },
        {
          name: "蔡聪",
          idCard: "513436200005306330",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1
          }
        },
        {
          name: "欧仪",
          idCard: "513436200005309734",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1
          }
        }
      ];
    }
  },
  methods: {
    onPay() {
      if (this.$refs.form.validate()) {
        if (!(this.form.businessLicenseFile instanceof File)) {
          this.$message.error("请上传营业执照");
          return false;
        }
        if (this.employees.length < 5) {
          this.$message.error("员工人数至少需要5人，请修改后重新提交");
          return false;
        }
        this.loading = true;
        const entity = this.transformToEntity();
        let formData = new FormData();
        formData.append("policyJson", JSON.stringify(entity));
        formData.append("file", this.form.businessLicenseFile);

        this.$axios
          .post("/app/api/gadd/submitPolicy", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(res => {
            const orderCode = res.data.orderCode;
            this.$router.push({ name: "pay", params: { orderCode } });
            this.loading = false;
          })
          .catch(err => {
            this.$message.error(err.message);
            this.loading = false;
          });
      }
    },
    transformToEntity() {
      return {
        userId:this.user.id,
        productId: this.code,
        productPlanId: this.form.productPlanId,
        startDate: this.form.effectBeginDate,
        insurancePeriod: this.form.effectDuration,
        insurancePeriodUnit: 2,
        amount: this.form.amount,
        applicantName: this.form.companyName,
        applicantIdentifyType: this.form.companyCardType,
        applicantIdentifyNumber: this.form.companyCardNo,
        contactName: this.form.contactName,
        contactEmail: this.form.contactEmail,
        officePhone: this.form.contactPhoneNumber,
        planList: this.planList,
        insuredList: this.employees.map(item => {
          return {
            name: item.name,
            identifyNumber: item.idCard,
            mobile: item.phone,
            jobCategory: item.category.code,
            jobName: item.category.name,
            jobLevel: item.category.level
          };
        })
      };
    },
    onUploadSuccess(file) {
      this.form.businessLicenseFile = file;
    }
  }
};
</script>


<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
}
</style>
